import { CalendarCheck, X, Bell, BellOff } from 'lucide-react';
import { useReviewReminder } from '../hooks/useReviewReminder';

export default function WeeklyReviewReminder({ onNavigateToReview }) {
  const {
    showReminder,
    dismissReminder,
    notificationPermission,
    requestNotificationPermission,
    loading
  } = useReviewReminder();

  if (loading || !showReminder) return null;

  const handleEnableNotifications = async () => {
    await requestNotificationPermission();
  };

  return (
    <div className="mx-3 md:mx-0 mb-4 p-4 bg-gradient-to-r from-accent/10 to-weekly/10 rounded-xl border border-accent/30 animate-in">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center flex-shrink-0">
          <CalendarCheck size={20} className="text-accent" />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-text-primary mb-1">
            Time for your Weekly Review
          </h3>
          <p className="text-sm text-text-secondary mb-3">
            It's Friday afternoon - the perfect time to clear your mind and prepare for next week.
          </p>

          <div className="flex flex-wrap items-center gap-2">
            <button
              onClick={onNavigateToReview}
              className="px-3 py-1.5 bg-accent text-white text-sm font-medium rounded-lg
                       hover:bg-orange-hover transition-colors border-none cursor-pointer"
            >
              Start Review
            </button>

            {notificationPermission === 'default' && (
              <button
                onClick={handleEnableNotifications}
                className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-text-secondary
                         bg-surface-card border border-border rounded-lg hover:bg-surface-hover
                         transition-colors cursor-pointer"
              >
                <Bell size={14} />
                Enable Reminders
              </button>
            )}

            {notificationPermission === 'denied' && (
              <span className="flex items-center gap-1.5 text-xs text-text-tertiary">
                <BellOff size={12} />
                Notifications blocked
              </span>
            )}
          </div>
        </div>

        <button
          onClick={dismissReminder}
          className="p-1.5 text-text-tertiary hover:text-text-secondary hover:bg-surface-hover
                   rounded-lg transition-colors border-none bg-transparent cursor-pointer"
          title="Dismiss for today"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
